import React from "react";
import AddToCartToSeePrice from "./AddToCartToSeePrice";
import { VariantProps } from ".";

const D = (props: VariantProps) => {
  const { selectedProduct } = props;

  return (
    <AddToCartToSeePrice
      {...props}
      showEnticement
      showLoginLink={
        selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers
      }
    />
  );
};

export default D;
